import React, { useMemo } from "react";

import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { MapsContext } from "../maps/context/context";
import useUrlParams from "../../../../customHooks/useUrlParams";

import { MarkerClusterer } from "@googlemaps/markerclusterer";
import useLoggedInUserDetails from "../../../../customHooks/useLoggedInUserDetails";
import {
  GetDataForMapsData,
  GetDataForMapsResult,
  GetDataForMapsVars,
} from "../masters/items/queries/types";
import { useLazyQuery } from "@apollo/client";
import { GetDataForMaps, GetItems } from "../masters/items/queries/queries";
import {
  emptyFunc,
  TicketStatus,
  ticketStatusOptions,
} from "../../../../utils/constants";
import Navbar from "../../../common/layout/Navbar";
import { empType, PriorityEnum } from "../../../../utils/Enum.types";
import Loading from "../../../../images/Loading.gif";
import RightArrow from "../../../../images/ArrowRight.svg";
import LocateAsset from "../../../../images/LocateAsset.svg";

import MyMaps from "./MyMaps";
import { APIProvider } from "@vis.gl/react-google-maps";
import { MapAutocomplete } from "./MapAutocomplete";
import { AppContext } from "../../../../context/context";
import { TableType } from "../../customer/companies/queries/types";
import { TicketStatusOptionsTypes } from "../../../../utils/types";
import MultipleTicketStatusSelect from "../../../../customComponents/MultipleTicketStatusSelect";
import useLabels from "../../../../customHooks/useLabels";
import TableTypeAutocomplete, {
  tableTypeOptions,
} from "../../../../customComponents/TableTypeAutocomplete";
import { GetUserRightsByEmpId } from "../users/AssignRights/queries/queries";
import {
  GetUserRightsByEmpIdResult,
  GetUserRightsByEmpIdVar,
} from "../users/AssignRights/queries/types";
import CompaniesAutocomplete from "../../customer/companies/CompaniesAutocomplete";
import { mapsPayloadType } from "../maps/context/reducer";
import SubsidiarySelect from "../../../../customComponents/SubsidiarySelect";
import SiteSelect from "../../../../customComponents/SiteSelect";
import JunctionsAutocomplete from "../../../../customComponents/JunctionsAutocomplete";
import useTableTypeOptions from "../../../../customHooks/useTableTypeOptions";
import { NavTypeProps } from "../maps/MapsIndex";
import SuppliersAutocomplete from "../purchase/purchaseorder/rfqtopo/components/SuppliersAutocomplete";
import { responseType } from "../../../../utils/formTypes";
import MultipleJunctionPrioritySelect from "../../../../customComponents/JunctionPriorityAutocomplete";
import MultipleJunctionTypesAutocomplete from "../../../../customComponents/JunctionTypesAutcomplete";
import ItemsAutocomplete from "../../../../customComponents/ItemsAutocomplete";
import { itmType } from "../purchase/material/statesProvider/materialContext";
import { LdgrQueryType } from "../masters/supplier/queries/types";
import Input from "../../../../stories/Input/Input";
import { Junction } from "../masters/subsidary/junctions/queries/types";

const Maps = ({ NavType }: NavTypeProps) => {
  const { state, dispatch } = useContext(MapsContext);
  const { state: globalState } = useContext(AppContext);

  const { customer_id } = useUrlParams();

  const { company_id, sub_id, siteID, junctionID } = useUrlParams();

  const { tableTypeOptions } = useTableTypeOptions();

  const {
    junctionLabel,
    companyLabel,
    subsidiaryLabel,
    subsidiarySiteLabel,
    itemLabel,
    ledgerLabel,
  } = useLabels();

  const clusterer = useRef<MarkerClusterer | null>(null);

  const [statusSelected, setStatusSelected] = useState<
    TicketStatusOptionsTypes[]
  >([]);

  const [selectedJunctionType, setSelectedJunctionType] = useState<string[]>(
    []
  );
  const [table, setTable] = useState<TableType>(TableType.COMPANY);

  const [GetRights, { data: rightsData }] = useLazyQuery<
    GetUserRightsByEmpIdResult,
    GetUserRightsByEmpIdVar
  >(GetUserRightsByEmpId);

  const [tableType, setTableType] = useState<tableTypeOptions | null>(null);

  const [items, setItems] = useState<GetDataForMapsResult[]>([]);

  const [searchItem, setSearchItem] = useState("");
  const [searchCoordinates, setSearchCoordinates] = useState("");
  const [priority, setPriority] = useState<PriorityEnum[]>([]);
  const [selectItm, setSelectItm] = useState<itmType | null>(null);
  const [selectedVendor, setSelectedVendor] = useState<responseType | null>(
    null
  );
  const [selectedJunction, setSelectedJunction] = useState<Junction | null>(
    null
  );

  const { user_details } = useLoggedInUserDetails();

  const [selectedPlace, setSelectedPlace] =
    useState<google.maps.places.PlaceResult | null>(null);

  const [GetAssetMaps, { data, loading }] = useLazyQuery<
    GetDataForMapsData,
    GetDataForMapsVars
  >(GetDataForMaps, {
    pollInterval: 20000,
  });

  const clearMarkers = () => {
    clusterer.current?.clearMarkers();
  };

  const selectedTableTypeAndId = useMemo(() => {
    if (state.junction || junctionID) {
      return {
        tableType: TableType.JUNCTION,
        id: junctionID
          ? junctionID
          : state.junction
          ? state.junction.node.id
          : 0,
      };
    } else if (state.site || siteID) {
      return {
        tableType: TableType.SITE,
        id: siteID ? siteID : state.site ? state.site.value : 0,
      };
    } else if (state.subsidary || sub_id) {
      return {
        tableType: TableType.SUBSIDIARY,
        id: sub_id ? sub_id : state.subsidary ? state.subsidary.node.id : 0,
      };
    } else if (state.company || company_id) {
      return {
        tableType: TableType.COMPANY,
        id: company_id ? company_id : state.company ? state.company.node.id : 0,
      };
    } else
      return {
        id: 0,
        tableType: TableType.CUSTOMER,
      };
  }, [
    state.site,
    state.subsidary,
    state.company,
    state.junction,
    state.companyId,
    company_id,
    sub_id,
    siteID,
    junctionID,
  ]);

  useEffect(() => {
    if (
      customer_id &&
      tableType &&
      ((tableType.value === TableType.ASSET && selectItm) ||
        tableType.value !== TableType.ASSET) &&
      !selectedJunction
    ) {
      GetAssetMaps({
        variables: {
          customerID: customer_id ? customer_id : 0,
          input: {
            id: selectedTableTypeAndId.id,
            idType: selectedTableTypeAndId.tableType,
            retTableType: tableType.value,
            ticketStatus: statusSelected.length
              ? Object.values(statusSelected.map(({ value }) => value))
              : [],
            empID: user_details.id,
            jType: selectedJunctionType,
            LdgrIds: selectedVendor ? [selectedVendor.value] : [],
            priority: priority,
            itemID: selectItm ? selectItm.value : 0,
          },
        },
      }).then(({ data }) => {
        if (data && data.GetDataForMaps) {
          setItems(data.GetDataForMaps);
        }
      });
    } else if (selectedJunction) {
      setItems([
        {
          id: selectedJunction.id,
          address: selectedJunction.address,
          companyID: selectedJunction.companyID,
          desc: "",
          icon: selectedJunction.icon,
          latitude: selectedJunction.latitude,
          longitude: selectedJunction.longitude,
          name: selectedJunction.name,
          prodSerialNo: "",
          ticketStatus: selectedJunction.ticketStatus,
        },
      ]);
      setSearchCoordinates(
        `${selectedJunction.latitude},${selectedJunction.longitude}`
      );
    } else {
      setItems([]);
    }
  }, [
    customer_id,
    state.company,
    state.subsidary,
    GetItems,
    statusSelected,
    searchItem,
    tableType,
    user_details.id,
    selectedTableTypeAndId,
    selectedVendor,
    priority,
    selectedJunctionType,
    selectItm,
    data,
    searchCoordinates,
    state.junction,
    GetAssetMaps,
    selectedJunction,
  ]);

  useEffect(() => {
    if (globalState.empSubType === empType.TECHNICIAN) {
      const filterOption = ticketStatusOptions.find(
        ({ value }) => value === TicketStatus.OPEN
      );
      if (filterOption) setStatusSelected([filterOption]);
    }
  }, [globalState.empSubType, ticketStatusOptions]);

  useEffect(() => {
    if (user_details.id && customer_id) {
      GetRights({
        variables: {
          empID: user_details.id,
          customerID: customer_id,
        },
      }).then(({ data }) => {
        if (data && data.GetUserRightsByEmpId) {
          setTable(data.GetUserRightsByEmpId.tableLevel);
          const foundEle = tableTypeOptions.find(
            ({ value }) => value === data.GetUserRightsByEmpId.tableLevel
          );
          setTableType(foundEle ? foundEle : null);
        }
      });
    }
  }, [user_details.id, rightsData, customer_id, tableTypeOptions, GetRights]);

  const enableTableType = useCallback(
    (assetType: TableType): boolean => {
      if (tableType)
        switch (assetType) {
          case TableType.COMPANY:
            return (
              table === TableType.COMPANY &&
              tableType.value !== TableType.COMPANY &&
              !company_id
            );
          case TableType.SUBSIDIARY:
            return (
              (table === TableType.COMPANY || table === TableType.SUBSIDIARY) &&
              tableType.value !== TableType.SUBSIDIARY &&
              tableType.value !== TableType.COMPANY &&
              !sub_id
            );
          case TableType.SITE:
            return (
              (table === TableType.COMPANY ||
                table === TableType.SUBSIDIARY ||
                table === TableType.SITE) &&
              tableType.value !== TableType.SITE &&
              tableType.value !== TableType.SUBSIDIARY &&
              tableType.value !== TableType.COMPANY &&
              !siteID
            );
          case TableType.JUNCTION:
            return (
              (table === TableType.COMPANY ||
                table === TableType.SUBSIDIARY ||
                table === TableType.SITE ||
                table === TableType.JUNCTION) &&
              tableType.value !== TableType.JUNCTION &&
              tableType.value !== TableType.SITE &&
              tableType.value !== TableType.SUBSIDIARY &&
              tableType.value !== TableType.COMPANY &&
              !junctionID
            );
        }
      return false;
    },
    [tableType, table]
  );

  return (
    <>
      <Navbar NavType={NavType} />
      <APIProvider apiKey={process.env.React_App_MAP!}>
        {loading ? (
          <div className="loading-container">
            <img src={Loading} alt="loading" className="loading-gif" />
          </div>
        ) : (
          <div className="maps">
            <div className="maps__flex">
              <MyMaps
                items={items}
                clusterer={clusterer}
                selectedPlace={selectedPlace}
                assetType={
                  tableType?.value
                    ? tableType?.value!
                    : selectedJunction && selectedJunction.id
                    ? TableType.JUNCTION
                    : TableType.ASSET
                }
                searchCoordinates={searchCoordinates}
                showIconFlag={selectedJunction ? false : true}
              />
              <div className="maps__flex--left">
                <input type="checkbox" id="total-asset" name="" />

                {loading ? (
                  <img src={Loading} alt="loading" className="loading-gif" />
                ) : (
                  <>
                    {/* <div className="maps__flex--input">
                      <Input
                        id="data_search"
                        placeholder="Search..."
                        onChange={(e) => {
                          setSearchItem(e.target.value);
                        }}
                      />
                    </div> */}
                    {/* <div className="maps__flex--left--hamburger">
                      <label htmlFor="total-asset">
                        <img src={Hamburger} alt="/" id="toggle" />
                      </label>
                    </div> */}
                    <div className="maps__flex--left--total-items">
                      <b>Total {itemLabel}</b>
                      <div className="maps__flex--left--total-items--flex">
                        <span>{items.length}</span>
                        <img src={LocateAsset} alt="" />
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className="maps__flex--right">
                <div className="maps__flex--right--header">
                  <div className="maps__flex--right--header--filters">
                    <input type="checkbox" id="filters" name="" />
                    <div className="maps__flex--right--filter">
                      <label htmlFor="filters">
                        <img src={RightArrow} alt="/" id="toggle" />
                      </label>
                    </div>
                    <div className="maps__flex--right--header--filters--bg">
                      <div className="maps__flex--right--flex">
                        <TableTypeAutocomplete
                          onChange={(newValue) => {
                            clearMarkers();
                            if (newValue) {
                              setTableType(newValue);
                            } else {
                              setTableType(null);
                              setSelectedJunction(null);
                            }
                          }}
                          onKeyDown={emptyFunc}
                          value={tableType ? tableType.value : null}
                          disableClearable={false}
                          placeholder="Table Type"
                        />
                      </div>

                      {tableType && tableType.value === TableType.ASSET ? (
                        <div className="maps__flex--right--flex">
                          <ItemsAutocomplete
                            onChange={(newValue) => {
                              if (newValue) {
                                setSelectItm(newValue);
                              } else {
                                setSelectItm(null);
                                setSelectedJunction(null);
                              }
                            }}
                            label=""
                            onKeyDown={emptyFunc}
                            value={selectItm ? selectItm.value : 0}
                            placeholder={itemLabel}
                            isComponent={false}
                          />
                        </div>
                      ) : null}
                      {enableTableType(TableType.COMPANY) ? (
                        <div className="maps__flex--right--flex">
                          <CompaniesAutocomplete
                            onChange={(newValue) => {
                              // clearMarkers();
                              if (newValue) {
                                dispatch({
                                  type: mapsPayloadType.COMPANY,
                                  payload: {
                                    company: newValue,
                                  },
                                });
                              } else {
                                dispatch({
                                  type: mapsPayloadType.COMPANY,
                                  payload: {
                                    company: null,
                                  },
                                });
                                setSelectedJunction(null);
                              }
                            }}
                            onKeyDown={emptyFunc}
                            value={state.company ? state.company.node.id : 0}
                            placeholder={companyLabel}
                          />
                        </div>
                      ) : null}
                      {enableTableType(TableType.SUBSIDIARY) ? (
                        <div className="maps__flex--right--flex">
                          <SubsidiarySelect
                            onChange={(newValue) => {
                              if (newValue) {
                                dispatch({
                                  type: mapsPayloadType.SUBSIDARY,
                                  payload: {
                                    subsidary: newValue,
                                  },
                                });
                              } else {
                                dispatch({
                                  type: mapsPayloadType.SUBSIDARY,
                                  payload: {
                                    subsidary: null,
                                  },
                                });
                                dispatch({
                                  type: mapsPayloadType.SITE,
                                  payload: {
                                    site: null,
                                  },
                                });
                                dispatch({
                                  type: mapsPayloadType.JUNCTION,
                                  payload: {
                                    junction: null,
                                  },
                                });
                                setSelectedJunction(null);
                              }
                            }}
                            label=""
                            companyID={
                              state.company ? state.company.node.id : 0
                            }
                            onKeyDown={emptyFunc}
                            value={
                              state.subsidary ? state.subsidary.node.id : 0
                            }
                            placeholder={subsidiaryLabel}
                          />
                        </div>
                      ) : null}
                      {enableTableType(TableType.SITE) ? (
                        <div className="maps__flex--right--flex">
                          <SiteSelect
                            onChange={(newValue) => {
                              if (newValue) {
                                dispatch({
                                  type: mapsPayloadType.SITE,
                                  payload: {
                                    site: newValue,
                                  },
                                });
                              } else {
                                dispatch({
                                  type: mapsPayloadType.SITE,
                                  payload: {
                                    site: null,
                                  },
                                });
                                dispatch({
                                  type: mapsPayloadType.JUNCTION,
                                  payload: {
                                    junction: null,
                                  },
                                });
                                setSelectedJunction(null);
                              }
                            }}
                            label=""
                            companyId={
                              state.company ? state.company.node.id : 0
                            }
                            subsidiaryId={
                              state.subsidary ? state.subsidary.node.id : 0
                            }
                            onKeyDown={emptyFunc}
                            value={state.site ? state.site.value : 0}
                            placeholder={subsidiarySiteLabel}
                          />
                        </div>
                      ) : null}

                      {enableTableType(TableType.JUNCTION) ? (
                        <div className="maps__flex--right--flex">
                          <JunctionsAutocomplete
                            onChange={(newValue) => {
                              if (newValue) {
                                dispatch({
                                  type: mapsPayloadType.JUNCTION,
                                  payload: {
                                    junction: newValue,
                                  },
                                });
                              } else {
                                dispatch({
                                  type: mapsPayloadType.JUNCTION,
                                  payload: {
                                    junction: null,
                                  },
                                });
                                setSelectedJunction(null);
                              }
                            }}
                            label=""
                            companyID={
                              state.company ? state.company.node.id : 0
                            }
                            subsidiaryID={
                              state.subsidary ? state.subsidary.node.id : 0
                            }
                            siteID={state.site ? state.site.value : 0}
                            onKeyDown={emptyFunc}
                            value={state.junction ? state.junction.node.id : 0}
                            placeholder={junctionLabel}
                          />
                        </div>
                      ) : null}

                      {tableType &&
                      (tableType.value === TableType.ASSET ||
                        tableType.value === TableType.JUNCTION) ? (
                        <div className="maps__flex--right--flex">
                          <SuppliersAutocomplete
                            onChange={(newValue) => {
                              if (newValue) {
                                setSelectedVendor(newValue);
                              } else {
                                setSelectedVendor(null);
                                setSelectedJunction(null);
                              }
                            }}
                            label=""
                            onKeyDown={emptyFunc}
                            value={selectedVendor ? selectedVendor.value : 0}
                            placeholder={ledgerLabel}
                            input={{
                              itemID:
                                tableType.value === TableType.ASSET && selectItm
                                  ? selectItm.value
                                  : 0,
                              query_type: LdgrQueryType.ALL,
                              tableLevel: tableType.value,
                            }}
                          />
                        </div>
                      ) : null}
                      {tableType &&
                      (tableType.value === TableType.ASSET ||
                        tableType.value === TableType.JUNCTION) ? (
                        <div className="maps__flex--right--flex">
                          <MultipleTicketStatusSelect
                            onChange={(newValue) => {
                              setStatusSelected(newValue);
                            }}
                            onKeyDown={emptyFunc}
                            value={statusSelected}
                            handleClear={emptyFunc}
                            // label="Status"
                            placeholder="Ticket Status"
                          />
                        </div>
                      ) : null}
                      {tableType && tableType.value === TableType.JUNCTION ? (
                        <div className="maps__flex--right--flex">
                          <MultipleJunctionTypesAutocomplete
                            onChange={(newValue) => {
                              if (newValue) {
                                setSelectedJunctionType(newValue);
                              } else {
                                setSelectedJunctionType([]);
                                setSelectedJunction(null);
                              }
                            }}
                            label=""
                            onKeyDown={emptyFunc}
                            autoCompleteValue={selectedJunctionType}
                            handleClear={emptyFunc}
                            placeholder={`${junctionLabel} Type`}
                          />
                        </div>
                      ) : null}

                      {tableType && tableType.value === TableType.JUNCTION ? (
                        <div className="maps__flex--right--flex">
                          <MultipleJunctionPrioritySelect
                            onChange={(newValue) => {
                              if (newValue) {
                                setPriority(newValue);
                              } else {
                                setPriority([]);
                                setSelectedJunction(null);
                              }
                            }}
                            label=""
                            autoCompleteValue={priority}
                            onKeyDown={emptyFunc}
                            placeholder="Priority"
                            handleClear={emptyFunc}
                          />
                        </div>
                      ) : null}
                    </div>
                  </div>

                  {/* <div className="maps__search">
                    <Input
                      id="data_search"
                      placeholder="Lat,Lng..."
                      onChange={(e) => {
                        setSelectedPlace(null);
                        setSearchCoordinates(e.target.value);
                      }}
                    />
                  </div>
                  <div>
                    <JunctionsAutocomplete
                      onChange={(newValue) => {
                        if (newValue) {
                          setSelectedJunction(newValue.node);
                        } else {
                          setSelectedJunction(null);
                        }
                      }}
                      label=""
                      companyID={state.company ? state.company.node.id : 0}
                      subsidiaryID={
                        state.subsidary ? state.subsidary.node.id : 0
                      }
                      siteID={state.site ? state.site.value : 0}
                      onKeyDown={emptyFunc}
                      value={selectedJunction ? selectedJunction.id : 0}
                      placeholder={junctionLabel}
                    />
                  </div> */}

                  <MapAutocomplete onPlaceSelect={setSelectedPlace} />
                </div>
<div className="row g-0 maps__flex--right--header-2">
                  <div className="col-2">
                    <JunctionsAutocomplete
                      onChange={(newValue) => {
                        if (newValue) {
                          setSelectedJunction(newValue.node);
                        } else {
                          setSelectedJunction(null);
                        }
                      }}
                      label=""
                      companyID={state.company ? state.company.node.id : 0}
                      subsidiaryID={
                        state.subsidary ? state.subsidary.node.id : 0
                      }
                      siteID={state.site ? state.site.value : 0}
                      onKeyDown={emptyFunc}
                      value={selectedJunction ? selectedJunction.id : 0}
                      placeholder={junctionLabel}
                    />
                  </div>
                  <div className="col-2">
                    <Input
                      id="data_search"
                      placeholder="Lat,Lng..."
                      className="lat-search"
                      onChange={(e) => {
                        setSelectedPlace(null);
                        setSearchCoordinates(e.target.value);
                      }}
                    />
                  </div>
                  </div>
                {/* <div
                  className="maps__flex--right--tabs"
                  onClick={() => setAddDrawer(!addDrawer)}
                >
                  <img src={Add} alt="/" />
                </div> */}
              </div>
            </div>
          </div>
        )}
      </APIProvider>
    </>
  );
};

export default Maps;
